import { __awaiter } from "tslib";
const API_ENDPOINTS = {
    v4: 'https://api.signality.com/v4',
    sandbox: 'https://api.signality.com/sandbox/v4',
};
export const login = (env, username, password) => __awaiter(void 0, void 0, void 0, function* () {
    const resp = yield fetch(`${API_ENDPOINTS[env]}/users/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            username,
            password,
        }),
    });
    const res = yield resp.json();
    if (resp.status !== 200) {
        throw new Error(res.error.message);
    }
    else {
        return res;
    }
});
export const fetchStreamUrl = (env, gameId, label, token) => __awaiter(void 0, void 0, void 0, function* () {
    const options = {
        method: 'GET',
        headers: {
            Authorization: `Bearer: ${token.token}`,
            Accept: 'application/json',
        }
    };
    const resp = yield fetch(`${API_ENDPOINTS[env]}/games/${gameId}/streams`, options);
    const data = yield resp.json();
    if (!resp.ok)
        throw new Error(data.error.message);
    // convert date string to Date
    const url = data
        .filter((s) => s.label === label)[0].url;
    return url;
});
